import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import {
  Tab,
  Tabs,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  ExpansionPanelActions,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Checkbox,
  IconButton
} from '@material-ui/core';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import BackIcon from '@material-ui/icons/ArrowBack';

import { InviteDialog } from '../components';

import { FarmProvider } from '../providers';
import DeleteFarmProvider, { DeleteFn } from '../providers/DeleteFarmProvider';
import FarmUsersProvider, { ChangeRoleFn, DeleteUserFn } from '../providers/FarmUsersProvider';

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  },
  content: {
    padding: theme.spacing.unit * 3,
    flex: 1,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  column: {
    flexBasis: '33.33%'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

interface State {
  tab: string;
  selectedUsers: string[];
  showInviteDialog: boolean;
  usersUpdating: boolean;
}

class FarmConfig extends React.Component<WithStyles & RouteComponentProps<any>, State> {
  state = {
    tab: 'settings',
    selectedUsers: [] as string[],
    showInviteDialog: false,
    usersUpdating: false
  };

  getUserRole = (user: FarmUser): string => {
    switch (user.role) {
      case 'user':
        return 'Usuario';
      case 'administrator':
        return 'Administrador';
      case 'owner':
        return 'Propietario';
      default:
        return '';
    }
  }

  isUserSelected = (userId: string) => {
    return this.state.selectedUsers.indexOf(userId) > -1;
  }

  toggleUser = (userId: string) => {
    if (this.isUserSelected(userId)) {
      this.setState({
        selectedUsers: this.state.selectedUsers.filter(id => id !== userId)
      });
    } else {
      this.setState({
        selectedUsers: [
          ...this.state.selectedUsers,
          userId
        ]
      });
    }
  }

  allUsersSelected = (users: FarmUser[]) => {
    return users.filter(u => u.role !== 'owner').length === this.state.selectedUsers.length;
  }

  selectAllUsers = (users: FarmUser[]) => {
    if (this.allUsersSelected(users)) {
      this.setState({
        selectedUsers: []
      });
    } else {
      this.setState({
        selectedUsers: users.filter(u => u.role !== 'owner').map(u => u.id)
      });
    }
  }

  changeRoles = (changeRoleFn: ChangeRoleFn, role: string) => {
    this.setState({ usersUpdating: true });
    changeRoleFn(this.state.selectedUsers, role);
  }

  deleteUsers = (deleteUserFn: DeleteUserFn) => {
    this.setState({ usersUpdating: true });
    deleteUserFn(this.state.selectedUsers);
  }

  renderSettings(deleteFn: DeleteFn, deleting: boolean) {
    const {
      classes,
      match: {
        params: { farmId }
      }
    } = this.props;

    return (
      <div className={classes.content}>
        <Grid
          container={true}
          spacing={24}
          style={{ maxWidth: 900 }}
        >
          <Grid item={true} xs={12}>
            <ExpansionPanel defaultExpanded={true}>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
              >
                <Typography className={classes.heading}>
                  Eliminar campo
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Typography>
                  Seleccione esta opción si desea eliminar su campo
                  de la plataforma. ADVERTENCIA: esta opeación no
                  puede deshacerse, toda la información de se campo
                  será eliminada de nuestros servidores.
                </Typography>
              </ExpansionPanelDetails>
              <Divider />
              <ExpansionPanelActions>
                <Button
                  size="small"
                  color="secondary"
                  onClick={() => confirm('¿Está seguro que desea eliminar su campo?') && deleteFn(farmId)}
                  disabled={deleting}
                >
                  Eliminar
                </Button>
              </ExpansionPanelActions>
            </ExpansionPanel>
          </Grid>
        </Grid>
      </div>
    );
  }

  renderUsers(farm: Farm, users: FarmUser[], changeRoleFn: ChangeRoleFn, deleteUserFn: DeleteUserFn) {
    const { classes } = this.props;
    const { selectedUsers, usersUpdating } = this.state;

    return (
      <div className={classes.content}>
        <Grid
          container={true}
          spacing={24}
          style={{ maxWidth: 900 }}
        >
          <Grid item={true} xs={12}>
            {farm.myRole !== 'user' ?
              <div style={{display: 'flex', flexDirection: 'row', marginBottom: 12}}>
                <div style={{flex: 0, flexBasis: 200}}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.setState({ showInviteDialog: true })}
                  >
                    Invitar nuevo usuario
                  </Button>
                </div>
                <div style={{flex: 1, textAlign: 'right'}}>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={selectedUsers.length === 0 || usersUpdating}
                    onClick={() => this.changeRoles(changeRoleFn, 'administrator')}
                  >
                    Cambiar administrador
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{marginLeft: 12}}
                    disabled={selectedUsers.length === 0 || usersUpdating}
                    onClick={() => this.changeRoles(changeRoleFn, 'user')}
                  >
                    Cambiar usuario
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{marginLeft: 12}}
                    disabled={selectedUsers.length === 0 || usersUpdating}
                    onClick={() => this.deleteUsers(deleteUserFn)}
                  >
                    Eliminar
                  </Button>
                </div>
              </div>
            : null}
            <Paper>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    {farm.myRole !== 'user' ?
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={!this.allUsersSelected(users) && selectedUsers.length > 0}
                          checked={this.allUsersSelected(users)}
                          onClick={() => this.selectAllUsers(users)}
                        />
                      </TableCell>
                    : null}
                    <TableCell>Nombre</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Rol</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(user =>
                    <TableRow
                      key={user.id}
                      hover={true}
                      role="checkbox"
                      selected={this.isUserSelected(user.id)}
                      onClick={
                        farm.myRole !== 'user' && user.role !== 'owner' ?
                          () => this.toggleUser(user.id) : undefined
                      }
                    >
                      {farm.myRole !== 'user' ?
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={this.isUserSelected(user.id)}
                            disabled={user.role === 'owner'}
                          />
                        </TableCell>
                      : null}
                      <TableCell>{user.firstName} {user.lastName}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{this.getUserRole(user)}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }

  render() {
    const {
      classes,
      match: {
        params: { farmId }
      }
    } = this.props;

    const { tab, showInviteDialog } = this.state;

    return (
      <FarmProvider farmId={farmId} includeUsers={true}>
        {(farm, farmLoading) =>
          !farm ? null : (
            <DeleteFarmProvider
              onCompleted={() => this.props.history.push('/explore')}
            >
              {(deleteFn, deleting) => (
                <FarmUsersProvider
                  farmId={farmId}
                  onCompleted={() => this.setState({usersUpdating: false})}
                >
                  {(changeRoleFn, deleteUserFn) =>
                    <main className={classes.root}>
                      <AppBar position="static" elevation={0}>
                        <Toolbar>
                          <IconButton
                            onClick={() => this.props.history.goBack()}
                            style={{marginRight: 8, color: '#FFF'}}
                          >
                            <BackIcon />
                          </IconButton>
                          <Typography variant="title" color="inherit" noWrap={true}>
                            {farm.name}
                          </Typography>
                        </Toolbar>
                        <Tabs value={tab} onChange={(event, value) => this.setState({tab: value})}>
                          <Tab value="settings" label="Configuración" />
                          <Tab value="users" label="Usuarios" />
                          <Tab value="payment" label="Plan de pago" />
                        </Tabs>
                      </AppBar>
                      {tab === 'settings' && this.renderSettings(deleteFn, deleting)}
                      {tab === 'users' && this.renderUsers(farm, farm.users, changeRoleFn, deleteUserFn)}

                      <InviteDialog
                        farmId={farmId}
                        show={showInviteDialog}
                        onDismiss={() => this.setState({ showInviteDialog: false })}
                      />
                    </main>
                  }
                </FarmUsersProvider>
              )}
            </DeleteFarmProvider>
          )
        }
      </FarmProvider>
    );
  }
}

export default withStyles(styles)(withRouter(FarmConfig));



// WEBPACK FOOTER //
// ./src/containers/FarmConfig.tsx